export default __webpack_public_path__ + "static/media/old-scratch.1039fd2f.jpg";